
import { messaging } from './lib/firebase';
import { getToken } from "firebase/messaging";
import { getDatabase, ref, push, set, get } from 'firebase/database';

function shouldAskNotificationPermission() {
    const denyCount = parseInt(localStorage.getItem('notifDenyCount') || '-1', 10);
    const lastAsked = parseInt(localStorage.getItem('notifLastAsked') || '-1', 10);
    const now = Date.now();
    const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;

    if(denyCount === -1 || lastAsked === -1) {
        return true
    }

    // Stop asking after 10 denies
    if (denyCount >= 10) return false;

    // Only ask again if 2 days have passed
    if (now - lastAsked < TWO_DAYS) return false;

    return true;
}


async function subscribeUser(userId: string) {
    if (!('Notification' in window)) {
        return null;
    }

    if (Notification.permission === 'denied') {
        return null;
    }

    if (Notification.permission !== 'granted' && !shouldAskNotificationPermission()) {
        console.warn('Notification permission denied too many times or too recent');
        return null;
    }

    try {
        const currentToken = await getToken(messaging, { vapidKey: 'BP27ZnO9pZDjMCza2TzIddKCDdyWEOtpOo3ju1Bpv1WLkS8F_ZwZtcqVj_FrWCs4tZjZB2iRYJD8_A7gA6aJV5A' });

        if (currentToken) {
            const existingToken = localStorage.getItem('fcmTokenNew');
            const db = getDatabase();
            
            if (existingToken !== currentToken) {
                localStorage.setItem('fcmTokenNew', currentToken);
                
                // Legacy saving for general subscribers
                const subscribersRef = ref(db, 'subscribers');
                const newSubscriberRef = push(subscribersRef);
                await set(newSubscriberRef, { token: currentToken, userId: userId });
            }

            // Always ensure the token is associated with this user
            if (userId) {
                const userTokensRef = ref(db, `users/${userId}/fcmTokens`);
                const snapshot = await get(userTokensRef);
                const tokens = snapshot.val() || {};
                
                let tokenExists = false;
                
                // Check if the token already exists in any format
                for (const key in tokens) {
                    if (key === currentToken) {
                        tokenExists = true; // Legacy key format
                        break;
                    }
                    if (tokens[key] && tokens[key].token === currentToken) {
                        tokenExists = true; // New object format
                        break;
                    }
                }

                if (!tokenExists) {
                    const newTokenRef = push(userTokensRef);
                    await set(newTokenRef, {
                        token: currentToken,
                        userAgent: navigator.userAgent,
                        timestamp: new Date().toISOString(),
                    });
                }
            }
            
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
        }
    } catch (error) {
        console.error('An error occurred while retrieving token.', error);
    }
}

export { subscribeUser };